import { FlatList } from 'react-native'
import { PdfItem } from './PdfItem'
import { styles } from './styles'

interface ListDataInterface {
  isDesktop: boolean
  data?: any
}

export const ListData = ({ isDesktop, data }: ListDataInterface) => {
  return (
    <FlatList
      data={data}
      numColumns={isDesktop ? 2 : 1}
      showsVerticalScrollIndicator={false}
      renderItem={({ item, index }) => <PdfItem item={item} index={index} isDesktop={isDesktop} />}
      contentContainerStyle={styles.contentContainerStyle}
      key={isDesktop ? 'm' : 'd'}
      keyExtractor={(item) => item.id}
    />
  )
}
